import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { BRAND, WHATSAPP_LINK } from "../lib/brand";

export const CTAStrip = ({
  heading = "Ready to automate your business?",
  sub = "Get a free demo. Our team will walk you through the right solution for your business.",
}) => (
  <section data-testid="cta-strip" className="gi-orange-gradient">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 flex flex-col md:flex-row items-center justify-between gap-8">
      <div className="text-white max-w-2xl">
        <h2 className="font-display font-bold text-3xl md:text-4xl leading-tight">{heading}</h2>
        <p className="mt-3 text-white/90 text-base">{sub}</p>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <Link
          to="/contact"
          data-testid="cta-strip-demo"
          className="bg-white text-[#F77F00] font-semibold px-6 py-3 rounded-lg hover:scale-105 transition inline-flex items-center gap-2"
        >
          Request a Demo <ArrowRight className="h-4 w-4" />
        </Link>
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-strip-whatsapp"
          className="border-2 border-white text-white font-semibold px-6 py-3 rounded-lg hover:bg-white hover:text-[#F77F00] transition inline-flex items-center gap-2"
        >
          <MessageCircle className="h-4 w-4" /> WhatsApp Us
        </a>
        <a
          href={`tel:${BRAND.phone1}`}
          data-testid="cta-strip-call"
          className="text-white font-medium inline-flex items-center gap-2 px-2"
        >
          <Phone className="h-4 w-4" /> {BRAND.phone1}
        </a>
      </div>
    </div>
  </section>
);

export default CTAStrip;
